import {getDeviceByIdNext, updateDeviceByIdNext} from "./actionType";

const initialState = {
  data:null,
  isLoading:true
}

export const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case getDeviceByIdNext.SUCCESS:
      return {...state, isLoading: false, data:payload }
    case getDeviceByIdNext.ERROR:
      return {...state, isLoading: false, data:null }
    case updateDeviceByIdNext.SUCCESS:
      return {...state}
    case updateDeviceByIdNext.ERROR:
      return {...state}
    default:
      return state
  }
}
